import { StyleSystemProps } from '@withjoy/joykit';

const mainContainerStyles: StyleSystemProps = {
  width: '100%',
};

export const styles = {
  mainContainer: mainContainerStyles,
};
